import PropTypes from 'prop-types';
import styled from 'styled-components';
import CheckboxOff from '../Icons/CheckboxOff';
import CheckboxOn from '../Icons/CheckboxOn';
import Paragraph from '../Paragraph/Paragraph';

const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
  position: relative;
  width: auto;
  max-width: max-content;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
`;

const CheckboxIconContainer = styled.div`
  margin-top: 2px;
`;

const Label = styled(Paragraph)``;

const Checkbox = ({ label, value, isBold, LabelPostfix, ...props }) => (
  <CheckboxContainer {...props}>
    <CheckboxIconContainer>
      {value ? <CheckboxOn /> : <CheckboxOff />}
    </CheckboxIconContainer>

    {label && (
      <Label weight={value && isBold ? 600 : 400}>
        {label} {!!LabelPostfix && <LabelPostfix />}
      </Label>
    )}
  </CheckboxContainer>
);

Checkbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  isBold: PropTypes.bool,
  LabelPostfix: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.shape({ render: PropTypes.func.isRequired }),
  ]),
};

Checkbox.defaultProps = {
  isBold: false,
};

export default Checkbox;
